export default {
    'ac-dc-power-supplies': [
        '',
        'Model Name',
        'Power',
        'Input Voltage',
        'Output Voltage',
        'Output Current',
        'Datasheet',
        'Stock Check',
        'RFQ',
    ],
    'dc-dc-converters': [
        '',
        'Model Name',
        'Power',
        'Input Voltage',
        'Output Voltage',
        'Output Current',
        'Datasheet',
        'Stock Check',
        'RFQ',
    ],
    'emi-filters': [
        '',
        'Model Name',
        'Rated Current',
        'Rated Voltage',
        'Mounting',
        'Filter Stages',
        'Datasheet',
        'Stock Check',
        'RFQ',
    ],
    'high-voltage-ac-dc': [
        '',
        'Model Name',
        'Power',
        'Output Voltage',
        'Input Voltage',
        'Package Size',
        'Datasheet',
        'RFQ'
    ],
    'high-voltage-dc-dc': [
        '',
        'Model Name',
        'Power',
        'Output Voltage',
        'Input Voltage',
        'Output Regulation',
        'Datasheet',
        'Stock Check',
        'RFQ',
    ],
    'high-voltage-power-solutions': [
        '',
        'Model Name',
        'Output Voltage',
        'Current',
        'Power',
        'Datasheet',
        'Stock Check',
        'RFQ',
    ],
    'rf-power': [
        '',
        'Model Name',
        'Power',
        'Input Voltage',
        'Frequency',
        'Datasheet',
        'RFQ',
    ]
}
